import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const KEY = 'cabrero_cookie_consent';

/**
 * Cookie consent banner — gates PostHog analytics on first visit.
 * Requires a global posthog stub (loaded in index.html with
 * `opt_out_capturing_by_default: true`). On "Aceptar" we call
 * `posthog.opt_in_capturing()`, on "Rechazar" we keep it opted out
 * and persist the choice in localStorage for 12 months.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raw;
    try { raw = localStorage.getItem(KEY); } catch (_) { /* SSR / disabled storage */ }
    if (raw === 'accepted') {
      enablePostHog();
      return;
    }
    if (raw === 'rejected') {
      disablePostHog();
      return; // already declined, do nothing
    }
    // First visit (or cleared): show banner after a tick so initial paint
    // is not blocked by it.
    const t = setTimeout(() => setVisible(true), 700);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, 'accepted'); } catch (_) { /* ignore */ }
    enablePostHog();
    setVisible(false);
  };

  const reject = () => {
    try { localStorage.setItem(KEY, 'rejected'); } catch (_) { /* ignore */ }
    disablePostHog();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Aviso de cookies" data-testid="cookie-banner">
      <div className="cb-inner">
        <div className="cb-text">
          <h3>Cookies en el Bar Cabrero</h3>
          <p>
            Usamos cookies <strong>técnicas</strong> (necesarias) y, si tú lo aceptas, <strong>analíticas</strong> para entender cómo se usa el sitio y mejorarlo. No usamos cookies publicitarias.
            Más detalles en nuestra <Link to="/politica-cookies">Política de Cookies</Link>.
          </p>
        </div>
        <div className="cb-actions">
          <button type="button" className="btn btn-o" onClick={reject} data-testid="cookie-reject">
            Rechazar
          </button>
          <button type="button" className="btn btn-g" onClick={accept} data-testid="cookie-accept">
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}

function enablePostHog() {
  try {
    if (typeof window !== 'undefined' && window.posthog?.opt_in_capturing) {
      window.posthog.opt_in_capturing();
    }
  } catch (err) {
    console.warn('posthog opt-in failed', err);
  }
}

function disablePostHog() {
  try {
    if (typeof window !== 'undefined' && window.posthog?.opt_out_capturing) {
      window.posthog.opt_out_capturing();
    }
  } catch (err) {
    console.warn('posthog opt-out failed', err);
  }
}
